import React, { ReactNode } from 'react';
import { Box, Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from "@castiron/components";

type Props = {
  primaryLabel: ReactNode;
  secondaryLabel?: ReactNode;
  containerClass?: string;
};

const useStyles = makeStyles((theme: Theme) => ({
  labelContainer: {
    marginTop: 17,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 9,
  },
  primaryLabel: {
    fontSize: 14,
    fontWeight: 700,
  },
  secondaryLabel: {
    fontSize: 14,
    fontWeight: 700,
    color: theme.branding.gray[700],
    textAlign: 'end',
  },
}));

const InputLabel: React.FC<Props> = (props: Props) => {
  const { primaryLabel, secondaryLabel, containerClass } = props;
  const classes = useStyles();

  return (
    <Box className={`${classes.labelContainer} ${containerClass}`}>
      {typeof primaryLabel === 'string' ? (
        <Typography className={classes.primaryLabel}>{primaryLabel}</Typography>
      ) : (
        primaryLabel
      )}
      {typeof secondaryLabel === 'string' ? (
        <Typography className={classes.secondaryLabel}>{secondaryLabel}</Typography>
      ) : (
        secondaryLabel
      )}
    </Box>
  );
};

export default InputLabel;
